import React from "react";
import styled, { css } from "styled-components";
var ArrowSvg = function ArrowSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "m8 2 1.057 1.058L4.872 7.25H14v1.5H4.872l4.185 4.193L8 14 2 8l6-6Z",
    fill: "#fff"
  }));
};
ArrowSvg.defaultProps = {
  width: "16",
  height: "16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
import getBorderRadius from "../../../utils/getBorderRadius";
import getColor from "../../../utils/getColor";
import space from "../../../utils/space";
export var arrowHeightSpace = 10;
var borderRadius = "small";
var StyledArrow = styled.button.withConfig({
  componentId: "sc-h206ya-0"
})(function (_ref) {
  var $direction = _ref.$direction,
    theme = _ref.theme;
  return css(["display:flex;align-items:center;justify-content:center;width:", ";height:", ";padding:0;border:0;background:", ";cursor:pointer;", " ", ""], space(5), space(10), getColor(theme, "backgroundDarker"), $direction === "left" && css(["border-top-right-radius:", ";border-bottom-right-radius:", ";"], getBorderRadius(theme, borderRadius), getBorderRadius(theme, borderRadius)), $direction === "right" && css(["border-top-left-radius:", ";border-bottom-left-radius:", ";svg{transform:rotate(180deg);}"], getBorderRadius(theme, borderRadius), getBorderRadius(theme, borderRadius)));
});
function ImageSliderMolArrow(_ref2) {
  var direction = _ref2.direction,
    onClick = _ref2.onClick,
    className = _ref2.className,
    tabIndex = _ref2.tabIndex,
    title = _ref2.title;
  return /*#__PURE__*/React.createElement(StyledArrow, {
    onClick: onClick,
    className: className,
    $direction: direction,
    tabIndex: tabIndex,
    title: title,
    "aria-label": title
  }, /*#__PURE__*/React.createElement(ArrowSvg, null));
}
export default ImageSliderMolArrow;